/* eslint-disable no-use-before-define */
import axios from 'services/axios.wrapper';
import config from 'services/config';

const { apiServer } = config;
const accountUrl = `${apiServer}/v1/iam/createaccount`;

export default {
  createAccount
};

function createAccount(account) {
  const promise = axios.post(accountUrl, {
    AccountName: account.accountName,
    Fbpn: account.fbpn,
    IsProducer: account.isProducer,
    IsUnverifiedFbpn: account.isUnverifiedFbpn
  });
  promise.catch(error => console.error(error));
  return promise;
}
